import React from 'react';
import { getProductImage } from '@beacharound/beacharound-ui-helpers';
import { Column, ColumnContainer, LoadingContainer, SectionTitle, Tile, TitleContainer } from '@beacharound/beacharound-ui';
import { getBundleTitle } from '../../helpers/products';

export default function BundlesList({ data, isLoading, daysNum, hidePrice }) {

    return (
        <LoadingContainer isLoading={isLoading}>
            {data?.length > 0 &&
                <ColumnContainer lowMargin>
                    <Column>
                        <TitleContainer lowMargin>
                            <SectionTitle text="Bundles" />
                        </TitleContainer>
                        {data?.sort((a, b) => a.price - b.price).map((item, index) => {

                            const { title, subtitle } = getBundleTitle(item, { main: true });
                            const price = Math.floor(item.price / daysNum).toFixed(2);
                            const priceComparison = item.priceComparison && Math.floor(item.priceComparison / daysNum).toFixed(2);

                            let pretitle;
                            if (!hidePrice) {
                                pretitle = `A partire da ${priceComparison ? `<strike>${priceComparison} €</strike> ` : ""}${price}€ al giorno`;
                            }

                            return (
                                <Tile
                                    key={index}
                                    highlight={priceComparison ? "In sconto!" : ""}
                                    images={item.relatedProducts?.map(prod => getProductImage(prod.reference?.type))}
                                    pretitle={pretitle}
                                    title={title}
                                    text={subtitle}
                                />
                            )
                        })}
                    </Column>
                </ColumnContainer>
            }
        </LoadingContainer>
    )
}